import { Component, OnInit } from '@angular/core';
import {interval, Observable, Subscription} from "rxjs";
import {cIO_MODBUS_ROOT, cIO_MODBUS_TREE} from "../../modbus/modbusData";
import {ModbusDescriptionDataservice} from "../../modbus/ModbusDescriptionDataservice";
import {cIOMAPPEDSERVO, MappedServoData} from "../mappedservoData";
import {MappedServoDataService} from "../MappedServoDataService";
import {DigitaloutdetailsComponent} from "../../digitalout/digitaloutdetails/digitaloutdetails.component";
import {MappedservodetailsComponent} from "../mappedservodetails/mappedservodetails.component";
import {DOState} from "../../digitalout/digitalOutStatus";
import {environment} from "../../../environments/environment";

@Component({
  selector: 'app-mappedservolister',
  templateUrl: './mappedservolister.component.html',
  styleUrls: ['./mappedservolister.component.css']
})
export class MappedservolisterComponent implements OnInit {

  private updateSubscription: Subscription | undefined;
  private errorMessage: any;
  componentList = Array<MappedservodetailsComponent>();
  public loaderStatus: number = 0;

  mappedServoData: MappedServoData | undefined;


  constructor(private mappedServoDataService: MappedServoDataService) {
  }

  private GetData(refNumber: number): cIOMAPPEDSERVO {
    if( ( this.mappedServoData) && (this.mappedServoData.cIO_MAPPED_SERVO[refNumber]))
      return this.mappedServoData.cIO_MAPPED_SERVO[refNumber];
    return new cIOMAPPEDSERVO();
  }


  ngOnInit(): void {

        this.UpdateData();

  }

  ngOnDestroy(): void {
    this.updateSubscription?.unsubscribe();
  }


  ReSubscribe(): void{
    this.updateSubscription = interval(environment.interval).subscribe(
      () => {
        this.UpdateData();
      });
  }

  UpdateData(): void {
    console.log('DO Status Unsubscribe');
    this.updateSubscription?.unsubscribe();
    this.loaderStatus = -1;
    this.mappedServoDataService.GetData().subscribe(
      {
        next: mappedServoData => {
          this.mappedServoData = mappedServoData;
          this.loaderStatus = 1;
          for (let detail of this.componentList) {
            detail.UpdateState(this.GetData(detail.refNumber));
          }
          this.ReSubscribe();
        }, error: err => {
          this.errorMessage = err;
          console.log("DO Update Error:", err);
        }
      });
  }



  Add(mappedservodetailsComponent: MappedservodetailsComponent): void
  {
    this.componentList.push(mappedservodetailsComponent);
  }

  counter(i: number) {
    return new Array(i);
  }


}
